export default (props) => (
  /**
   * Ícone ponta de seta.
   * Podendo ser utilizada para aumentar a tabela de atributos
   * para a esquerda, para cima e para baixo (voltando ao default).
   */
  <svg
    width="30"
    height="9"
    viewBox="0 0 30 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7709 0.889339L0.299041 7.39155C0.0438408 7.50632 -0.0699191 7.80608 0.044516 8.06094C0.159289 8.31614 0.459048 8.4299 0.713911 8.31513L15.0001 1.8963L29.2862 8.31547C29.5411 8.4299 29.8409 8.31614 29.9556 8.06094C30.0697 7.80574 29.9563 7.50598 29.7011 7.39155L15.2296 0.889339C15.155 0.855582 15.0767 0.841741 15.0001 0.845117C14.9234 0.841741 14.8455 0.855582 14.7709 0.889339Z"
      fill="currentColor"
    />
  </svg>
);
